<template>
  <!-- 自定义实现menu -->
  <div class="f-c">
    <NavigationMenu>
      <NavigationMenuList class="f-c flex-row gap-2">
        <NavigationMenuItem v-for="item in routes" :key="item.path">
          <div
            class="menu-item_one br-3 text-base hover:bg-accent hover:cursor-pointer rounded-md leading-4 py-2"
            :class="[isPathPrefix(item.path) ? 'bg-active cursor-pointer' : '']"
            v-if="item.children?.length == 0"
          >
            <LinkItem :to="item.path" class="br-3 text-5 hover:bg-accent hover:cursor-pointer fc relative text-black py-2 px-4 rounded-md">
              <SvgIcon
                v-if="item.meta?.svgIcon"
                :name="item.meta?.svgIcon as string"
                class="inline align-middle mr-2 text-base dark:text-white"
              />
              <span class="align-middle dark:text-white">{{ item.meta?.title }}</span>
            </LinkItem>
          </div>
          <div v-else>
            <NavigationMenuTrigger :class="[isPathPrefix(item.path) ? 'bg-active cursor-pointer' : '']">
              <div class="rounded-sm flex items-center relative text-black">
                <SvgIcon
                  v-if="item.meta?.svgIcon"
                  :name="item.meta?.svgIcon as string"
                  class="align-middle min-w-1 mr-2 text-base dark:text-white"
                />
                <span class="align-middle text-base dark:text-white">{{ item.meta?.title }}</span>
                <!-- <SvgIcon name="arraw" class="icon-arraw" /> -->
              </div>
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <!-- <NavigationMenuLink>Link</NavigationMenuLink> -->
              <SubMenu :menu="item"></SubMenu>
            </NavigationMenuContent>
          </div>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  </div>
</template>
<script lang="ts" setup>
import SubMenu from './SubMenu.vue';
import { computed } from 'vue';

const route = useRoute();
const routes = nestRoutes();
const activeMenu = computed(() => {
  const {
    meta: { activeMenu },
    path,
  } = route;
  return activeMenu ? activeMenu : path;
});

const isPathPrefix = (path2: string) => {
  const path1 = activeMenu.value as string;
  const p1 = path1.split('/');
  const p2 = path2.split('/');
  return p2?.every((val, index) => val === p1[index]);
};

const realPath = (left: string, right: string) => {
  if (left.endsWith('/') && right.startsWith('/')) {
    return left + right.slice(1);
  } else if (!left.endsWith('/') && !right.startsWith('/')) {
    return left + '/' + right;
  } else {
    return left + right;
  }
};
// console.log(activeMenu.value);
</script>
